import {
  Alert,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

export const PUBLICATION_PROPERTY = "dataListPublication";

const COLUMN_TYPES = {
  Text: ["TEXTO_STRING", "HYPERLINK"],
  Number: ["NUMERO"],
  Date: ["DATA_HORA"],
  CPF: ["CPF"],
  CNPJ: ["CNPJ"],
};

export function publicationTypes(field) {
  return COLUMN_TYPES[field?.type?.name || field?.type] || [];
}

export function publicationConfig(field) {
  return field?.properties?.find(
    (property) => property.id === PUBLICATION_PROPERTY,
  )?.value;
}

export function publicationError(field, lists) {
  const config = publicationConfig(field);
  if (!config) return "";
  const list = lists?.find(
    (entry) => entry.id === config.listCode && entry.situation === "ATIVO",
  );
  const column = list?.columns?.find(
    (entry) => entry.name === config.columnName,
  );
  if (!list) return "Selecione uma lista ativa e disponível.";
  if (
    !column ||
    !publicationTypes(field).includes(column.type) ||
    column.type !== config.columnType
  ) {
    return "Selecione uma coluna compatível com o tipo da variável.";
  }
  return "";
}

export default function DataListPublication({
  field,
  isStartForm = false,
  lists = [],
  loading,
  loadError,
  onChange,
  error,
}) {
  const config = publicationConfig(field);
  const types = publicationTypes(field);
  const availableLists = lists.filter((entry) => entry.situation === "ATIVO");
  const list = availableLists.find((entry) => entry.id === config?.listCode);
  const columns =
    list?.columns?.filter((column) => types.includes(column.type)) || [];

  return (
    <Stack spacing={2}>
      <FormControlLabel
        label="Enviar para uma Lista de Dados"
        control={
          <Checkbox
            checked={Boolean(config)}
            disabled={!types.length && !config}
            onChange={(_, checked) => onChange(checked ? {} : null)}
          />
        }
      />
      <Typography variant="body2">
        {isStartForm
          ? "Ao enviar o formulário inicial e criar o processo, o valor será adicionado à lista."
          : "Ao concluir esta tarefa, o valor será adicionado à lista."}{" "}
        Variáveis enviadas para a mesma lista serão agrupadas em uma linha. A
        publicação ocorre em segundo plano e uma falha no envio não impede{" "}
        {isStartForm ? "a criação do processo." : "a conclusão da tarefa."}
      </Typography>
      {!types.length && (
        <Alert severity="info">
          Disponível para texto, número, data/hora, CPF e CNPJ.
        </Alert>
      )}
      {config && (
        <>
          {loading && (
            <Typography variant="body2">Carregando listas...</Typography>
          )}
          {loadError && (
            <Alert severity="error">
              Não foi possível carregar as listas. Feche e abra a configuração
              para tentar novamente.
            </Alert>
          )}
          {!loading && !loadError && !availableLists.length && (
            <Alert severity="info">Nenhuma lista ativa disponível.</Alert>
          )}
          <TextField
            select
            fullWidth
            required
            label="Lista de Dados"
            value={list?.id || ""}
            disabled={loading || Boolean(loadError)}
            onChange={(event) => onChange({ listCode: event.target.value })}
          >
            {availableLists.map((entry) => (
              <MenuItem key={entry.id} value={entry.id}>
                {entry.name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            fullWidth
            required
            label="Coluna da lista"
            value={
              columns.some((column) => column.name === config.columnName)
                ? config.columnName
                : ""
            }
            disabled={!list || loading}
            helperText="São exibidas apenas colunas compatíveis com o tipo da variável."
            onChange={(event) => {
              const column = columns.find(
                (entry) => entry.name === event.target.value,
              );
              onChange({
                listCode: list.id,
                columnName: column.name,
                columnType: column.type,
              });
            }}
          >
            {columns.map((column) => (
              <MenuItem key={column.name} value={column.name}>
                {column.label || column.name}
                {column.required ? " *" : ""}
              </MenuItem>
            ))}
          </TextField>
          {list && !columns.length && (
            <Alert severity="info">
              Esta lista não possui colunas compatíveis.
            </Alert>
          )}
          {error && <Alert severity="error">{error}</Alert>}
        </>
      )}
    </Stack>
  );
}
